import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { EmailService } from '../services/email/email.service';
import { SessionService } from '@app/shared/services';
import { ROUTES } from '../../clpbp-app.settings';

@Component ({
  templateUrl: 'accept-email-verify.template.html',
  styleUrls: ['accept-email-verify.style.css'],
})
export class AcceptEmailVerifyComponent implements OnInit {
  error: boolean;
  loading: boolean;
  verifyGuid: string;
  shouldCheckIsDirty: boolean = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private emailService: EmailService,
    private router: Router,
    private sessionService: SessionService) {

    this.error = false;
  }

  ngOnInit(): void {

    this.verifyGuid = this.activatedRoute.snapshot.params['id'];

    // Now that we have the verify GUID we can attempt to verify the mail.  Note that this should put the page into a
    // 'verifying' state until complete, at which point the content finalizes.
    this.loading = true;

    this.emailService.verifyEmail(this.verifyGuid).subscribe(data => {
      this.loading = false;
    }, err => {
      this.error = true;
      this.loading = false;
      console.error(err);
    });
  }

  continueButtonPressed(): void {
    const borrowerIsLoggedIn: boolean = !!this.sessionService.data.authData.token;

    if (borrowerIsLoggedIn) {
      this.router.navigate([ `/${ ROUTES.PL_FULL }/dashboard` ]);
      return;
    }

    this.router.navigate([ `/${ ROUTES.PL_FULL }/login` ]);
  }
}
